import { IHttpApi } from '@cian/http-api/shared/http';

import { TMappedAnswersState } from '../types';
import {
  fetchCreateConsultationMessage,
  ICreateConsultationMessageResponse200,
  ICreateConsultationMessageResponse400,
} from '../../../repositories/demand/v1/create-consultation-message';

interface IParams {
  httpApi: IHttpApi;
  mappedAnswersState: TMappedAnswersState;
}

export const createConsultationRequest = async (params: IParams) => {
  const { httpApi, mappedAnswersState } = params;
  const { phone, email, fullName, comment, cooperationStatus } = mappedAnswersState;

  const parameters = {
    fullName,
    phone,
    email,
    cooperationStatus,
    comment: comment as string,
    isTest: true,
  };

  return fetchCreateConsultationMessage<ICreateConsultationMessageResponse200, ICreateConsultationMessageResponse400>({
    httpApi,
    parameters,
  });
};
